module.exports = __webpack_public_path__ + "static/media/spotify-d.80d429da.svg";